import { render } from "./SecondaryBtn.vue?vue&type=template&id=48d01910&scoped=true"
import script from "./SecondaryBtn.vue?vue&type=script&lang=js"
export * from "./SecondaryBtn.vue?vue&type=script&lang=js"

import "./SecondaryBtn.vue?vue&type=style&index=0&id=48d01910&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48d01910"

export default script